import { Button, Image, TextSize, Weight } from 'components'
import styled, { css } from 'styled-components'

import { GLOBAL_COLORS } from 'theme'

/**
 * Styling for the performance (exposure) title
 */
export const PerformanceTitle = styled.span`
  color: ${({ theme }) => theme.primaryFontColor};
  font-size: ${TextSize.h4};
  font-weight: ${Weight.Bold};
  line-height: 110%;
  letter-spacing: -0.8px;
  max-width: 640px;
  margin: 0;
`

/**
 * Container for the product performance content, a flex container with two columns
 */
export const PerformanceContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`

export const PerformanceListWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  & > div:last-child {
    border-bottom: none;
  }
  & > div:nth-child(2) {
    padding-top: 0;
  }
`

export const PerformanceItem = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #d9d9d9;
  padding: 20px 0;
`

export const PerformanceHeaders = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  padding: 28px 0;
  gap: 3px;
`

export const ProductDetails = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 410px;
  align-items: center;
`

export const ProductNameAndDescription = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`
export const ProductTitle = styled.span`
  color: ${({ theme }) => theme.primaryFontColor};
  font-size: ${TextSize.two};
  font-weight: ${Weight.Bold};
  line-height: 130%;
`
export const ProductShortTitle = styled.span`
  text-transform: uppercase;
  font-size: ${TextSize.two};
  line-height: 130%;
  color: ${({ theme }) => theme.primaryFontColor};
  opacity: 0.4;
`

export const TotalExposureDescription = styled.span`
  font-size: ${TextSize.small};
  line-height: 130%;
  opacity: 0.6;
`

export const ProductDescription = styled(TotalExposureDescription)`
  text-align: center;
`

export const ProductDelta = styled.div<{ isPositive?: boolean }>`
  color: ${({ isPositive }) =>
    isPositive
      ? css`
          ${GLOBAL_COLORS.secondaryGreen}
        `
      : css`
          ${GLOBAL_COLORS.volcanoRed}
        `};
  width: 70px;
  text-align: center;
`

export const MarketDetails = styled.div`
  width: 115px;
  text-align: center;
`

export const MarketChart = styled.div`
  width: 150px;
  text-align: center;
  height: 70px;
`

export const MarketCapHeader = styled.div`
  width: 115px;
  text-align: center;
  font-size: 12px;
  line-height: 130%;
  opacity: 0.6;
  margin-left: 390px;
`

export const HeaderContainer = styled.div`
  width: 70px;
  text-align: center;
  font-size: 12px;
  line-height: 130%;
  opacity: 0.6;
`

export const InvestInProductButton = styled(Button)`
  width: 80px;
  height: 34px;
  margin: auto;
`
export const PerformancePageWrapper = styled.div`
  width: 100%;
  max-height: 1024px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  max-width: 825px;
  padding: 0 85px;
  margin: 0 auto;
`
export const SkeletonWrapper = styled.div`
  width: 100%;
`
export const SkeletonWhitepaperWrapper = styled.div`
  width: 100%;
  text-align: center;
`

export const IconWrapper = styled(Image)`
  height: 32px;
  width: 32px;
  border-radius: 50%;
`
